import React from 'react';
import { Doughnut } from 'react-chartjs-2';

const CustomerRepeatRate = ({ data }) => {
    if (!data || data.total_customers === 0) return null;

    const chartData = {
        labels: ['New Customers', 'Returning Customers'],
        datasets: [{
            data: [data.new_customers, data.returning_customers],
            backgroundColor: ['#3B82F6', '#10B981'],
            borderWidth: 1,
        }],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { position: 'bottom', labels: { boxWidth: 12, padding: 8, font: { size: 11 } } },
        },
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Customer Repeat Rate</h6>
                <Doughnut data={chartData} options={options} />
                <div className="row mt-3 text-center g-2">
                    <div className="col-4">
                        <small className="text-muted d-block">Total Customers</small>
                        <strong>{data.total_customers}</strong>
                    </div>
                    <div className="col-4">
                        <small className="text-muted d-block">New</small>
                        <strong>{data.new_customers}</strong>
                    </div>
                    <div className="col-4">
                        <small className="text-muted d-block">Repeat Rate</small>
                        <strong className="text-success">{data.repeat_rate}%</strong>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerRepeatRate;
